import API_PUBLIC_SERVICE, { publicInstance, SERVER_API } from './http';

const PREFIX = 'communes';
const path = PREFIX;

const pagePath = '/commune';
const pagesRoute = {
  editPage: val => `${pagePath}/edit/${val}/`,
  addPage: () => `${pagePath}/add/`,
  listPage: () => `${pagePath}/list/`
};
const tableData = {
  tableName: '',
  tableHeader: [
    {
      id: 'code',
      key: 'code',
      disablePadding: false,
      numeric: false,
      label: 'Código'
    },
    {
      id: 'nameEFX',
      key: 'nameEFX',
      disablePadding: false,
      numeric: false,
      label: 'Comuna EFX'
    },
    {
      id: 'name',
      key: 'name',
      disablePadding: false,
      numeric: false,
      label: 'Nombre'
    },
    {
      id: 'province',
      key: 'province',
      disablePadding: false,
      numeric: false,
      label: 'Provincia'
    },
    {
      id: 'regionName',
      key: 'regionName',
      disablePadding: false,
      numeric: false,
      label: 'Región'
    },
    {
      id: '_id',
      key: '_id',
      disablePadding: false,
      numeric: false,
      label: 'Acciones',
      style: {
        width: '130px'
      },
      actions: pagesRoute
    }
  ],
  getKeyTable: () => '_id',
  makeDataTable: values => {
    return values.map(value => {
      return {
        ...value,
        regionName: value.region ? value.region.name : ''
      };
    });
  },
  hasAddOption: true,
  hasCheckbox: false,
  isAdvancedDateFilter: false,
  ...pagesRoute
};

const perRegion = async id => {
  const prefix = 'by-region';
  try {
    const res = await publicInstance.get(`${SERVER_API}${path}/${prefix}/${id}`);
    let { data } = await res;
    return data;
  } catch (e) {
    console.log(e);
  }
};

const CommuneService = {
  path,
  ...API_PUBLIC_SERVICE,
  ...tableData,
  perRegion
};

export default CommuneService;
